import { Grid, IconButton, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Print from '@material-ui/icons/Print'
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt'
import abbreviate from 'abbreviate-name'
import React, { useEffect, useState } from 'react'
import ReactToPrint from 'react-to-print'
import logoG10 from '../../images/g10-resumo.png'
import logoTP from '../../images/tp-resumo.png'
import { BRAND } from '../../branding'
import { formatCpf, formatCpfCnpj, formatCurrency } from '../../utils/Formatter'
import ResumoCard from './Resumo/ResumoCard'
import { AnaliseDocumentoIndicator } from './AnaliseDocumentoIndicator'
import { canPrintProtocolo } from './utils'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0, 6, 6, 6),
    '@media print': {
      padding: theme.spacing(2)
    }
  }
}))

const Items = ({
  centroCusto,
  columnSize,
  nomeMotorista,
  cpfMotorista,
  nomeEmbarcador,
  nomeProprietario,
  cpfCnpjProprietario,
  composicao,
  mercadoria,
  cliente,
  valorCarga
}) => {
  return (
    <>
      <Grid item sm={6} md={4} xs={columnSize}>
        <Typography variant="caption">Nome Motorista</Typography>
        <Typography variant="body1" noWrap={false}>
          {nomeMotorista ? abbreviate(nomeMotorista) : '--'}
        </Typography>
      </Grid>
      <Grid item sm={6} md={4} xs={columnSize}>
        <Typography variant="caption">CPF</Typography>
        <Typography variant="body1" noWrap={false}>
          {cpfMotorista ? formatCpf(cpfMotorista) : '--'}
        </Typography>
      </Grid>
      <Grid item sm={6} md={4} xs={columnSize}>
        <Typography variant="caption">Composição</Typography>
        <Typography variant="body1" noWrap={false}>
          {composicao.join(' -> ') || '--'}
        </Typography>
      </Grid>
      <Grid item sm={6} md={4} xs={columnSize}>
        <Typography variant="caption">Nome Proprietário</Typography>
        <Typography variant="body1" noWrap={false}>
          {nomeProprietario || '--'}
        </Typography>
      </Grid>
      <Grid item sm={6} md={4} xs={columnSize}>
        <Typography variant="caption">CPF/CNPJ</Typography>
        <Typography variant="body1" noWrap={false}>
          {cpfCnpjProprietario ? formatCpfCnpj(cpfCnpjProprietario) : '--'}
        </Typography>
      </Grid>
      <Grid item sm={6} md={4} xs={columnSize}>
        <Typography variant="caption">Centro de Custo</Typography>
        <Typography variant="body1" noWrap={false}>
          {centroCusto?.descricao || '--'}
        </Typography>
      </Grid>
      <Grid item sm={6} md={4} xs={columnSize}>
        <Typography variant="caption">Unidade de Negócio</Typography>
        <Typography variant="body1" noWrap={false}>
          {centroCusto?.unidadeNegocio?.descricao || '--'}
        </Typography>
      </Grid>
      <Grid item sm={6} md={4} xs={columnSize}>
        <Typography variant="caption">Embarcador</Typography>
        <Typography variant="body1" noWrap={false}>
          {nomeEmbarcador ? abbreviate(nomeEmbarcador) : '--'}
        </Typography>
      </Grid>
      <Grid item sm={6} md={4} xs={columnSize}>
        <Typography variant="caption">Mercadoria</Typography>
        <Typography variant="body1" noWrap={false}>
          {mercadoria || '--'}
        </Typography>
      </Grid>
      <Grid item sm={6} md={4} xs={columnSize}>
        <Typography variant="caption">Cliente</Typography>
        <Typography variant="body1" noWrap={false}>
          {cliente || '--'}
        </Typography>
      </Grid>
      <Grid item sm={6} md={4} xs={columnSize}>
        <Typography variant="caption">Valor Carga</Typography>
        <Typography variant="body1" noWrap={false}>
          {valorCarga ? formatCurrency(valorCarga) : '--'}
        </Typography>
      </Grid>
    </>
  )
}

const SolicitacaoCard = ({
  nomeMotorista,
  cpfMotorista,
  nomeEmbarcador,
  nomeProprietario,
  cpfCnpjProprietario,
  composicao,
  mercadoria,
  cliente,
  valorCarga,
  empresa,
  printRef,
  printRefCompleto,
  showResumo,
  centroCusto,
  dataTermino,
  status,
  match,
  isPrinting,
  analiseDocumentos,
  fonteLiberacao
}) => {
  const classes = useStyles()
  const [canPrint, setCanPrint] = useState(false)

  useEffect(() => {
    canPrintProtocolo({ status, dataTermino, fonteLiberacao }).then(setCanPrint)
  }, [status, dataTermino, fonteLiberacao])

  const columnSize = isPrinting ? 4 : 12

  return (
    <Paper>
      <Grid container>
        {analiseDocumentos && (
          <Grid item xs={12}>
            <AnaliseDocumentoIndicator />
          </Grid>
        )}
        <Grid item xs={12}>
          <Grid
            spacing={1}
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-end"
          >
            <Grid item xs />
            {canPrint && (
              <Grid item xs="auto">
                <ReactToPrint
                  trigger={() => (
                    <IconButton aria-label="Imprimir" className="no-print">
                      <Print />
                    </IconButton>
                  )}
                  content={() => printRef.current}
                />
              </Grid>
            )}
            {printRefCompleto && (
              <Grid item xs="auto">
                <ReactToPrint
                  trigger={() => (
                    <IconButton aria-label="Imprimir" className="no-print">
                      <SystemUpdateAltIcon />
                    </IconButton>
                  )}
                  content={() => printRefCompleto.current}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            className={classes.root}
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={2}
          >
            <Grid item xs={4}>
              {isPrinting ? (
                <img
                  src={BRAND.logo}
                  width={100}
                  height={28}
                  alt={BRAND.displayName || BRAND.name}
                />
              ) : (
                <>
                  {empresa === 'G10' && (
                    <img src={logoG10} width={100} height={28} alt="Logo G10" />
                  )}
                  {empresa === 'TP' && (
                    <img src={logoTP} width={100} height={28} alt="Logo TP" />
                  )}
                </>
              )}
            </Grid>
            <Items
              centroCusto={centroCusto}
              columnSize={columnSize}
              nomeMotorista={nomeMotorista}
              cpfMotorista={cpfMotorista}
              nomeEmbarcador={nomeEmbarcador}
              nomeProprietario={nomeProprietario}
              cpfCnpjProprietario={cpfCnpjProprietario}
              composicao={composicao}
              mercadoria={mercadoria}
              cliente={cliente}
              valorCarga={valorCarga}
            />
            {showResumo && (
              <Grid item xs={12}>
                <ResumoCard match={match} />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default React.memo(SolicitacaoCard)
